export default "__VITE_ASSET__CKTCwpsP__"